import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { ImageTile } from '@/features/editor/widgets/custom-widget/inputs/background/image/shared/image-tile';
import { ImageEditorModal } from '@/features/editor/widgets/custom-widget/inputs/background/image';
import { EditorContext } from '@/features/editor/context/editor-context';
import Portal from '@/components/portal';
import { INSPECTOR_WRAPPER_ID } from '@/features/editor/inspector';

export interface HtmlAttrImageInputProps {
  initialValue?: string;
  onChange?: (value: string) => void;
}

export function HtmlAttrImageInput({
  initialValue,
  onChange,
}: HtmlAttrImageInputProps) {
  const [value, setValue] = React.useState(initialValue || ``);
  const [savedImage, setSavedImage] = React.useState(initialValue || ``);
  const [isImageEditorOpen, setIsImageEditorOpen] = React.useState(false);

  const imageRef = useRef<HTMLElement>(null);
  const { inspectorRef } = useContext(EditorContext);

  const isSavedRef = useRef(false);

  const getModalRect = () =>
    ({
      width: inspectorRef?.current.getBoundingClientRect().width,
      left: inspectorRef?.current.getBoundingClientRect().left,
      height: window.innerHeight,
      top: 0,
    } as DOMRect);

  const onUpdateImagePreview = (blob: string) => {
    onChange?.(blob);
  };

  const onUpdateImage = (link: string) => {
    setValue(link);
    onChange?.(link);
  };

  const onClose = () => {
    if (isSavedRef.current === false) {
      setValue(initialValue);
      onChange?.(initialValue);
    }
    setIsImageEditorOpen(false);
  };

  return (
    <>
      <Wrapper ref={imageRef}>
        <span>Image Source</span>
        <ImageTile onClick={() => setIsImageEditorOpen(true)} src={value} />
      </Wrapper>
      {isImageEditorOpen && (
        <Portal selector={`#${INSPECTOR_WRAPPER_ID}`}>
          <ModalLike
            style={{
              top: inspectorRef?.current.getBoundingClientRect().top,
              right: 0,
              bottom: 0,
              left: inspectorRef?.current.getBoundingClientRect().left,
            }}
          >
            <ImageEditorModal
              isSavedRef={isSavedRef}
              savedImage={savedImage}
              setSavedImage={setSavedImage}
              image={value}
              onUpdatePreview={onUpdateImagePreview}
              onUpdateImage={onUpdateImage}
              onClose={onClose}
              getModalRect={getModalRect}
            />
          </ModalLike>
        </Portal>
      )}
    </>
  );
}

const Wrapper = styled(InlineInputCardWrapper)`
  && {
    display: grid;
    grid-template-columns: auto 1fr;

    .image-preview-tile {
      max-width: 4rem;
      max-height: 4rem;
      width: auto;
      justify-self: flex-end;
    }
  }
`;

export const ModalLike = styled.div`
  display: flex;
  position: fixed;
  z-index: 10000000;
  height: 100vh;
  background: white;
  padding-top: 3rem;
  justify-content: center;
  align-items: center;

  && > div {
    width: 100%;
  }

  div[direction='column'] {
    background-color: white;
  }
`;
